import { createSwitchController } from '@atlassian/jira-switch-controller/src/index.tsx';

const { useSwitch } = createSwitchController<string | undefined>('jira-switch-modals');

export const useSwitchModals = useSwitch;

export type UseSwitchModalsType = typeof useSwitch;
